import type { TemporaryMaterial } from '../../features/materials/materialsSlice';
import { MaterialPreviewModal } from './shared/MaterialPreviewModal';
import { useTemporaryMaterials } from '../../features/materials/hooks';

type Props = {
  material: TemporaryMaterial;
  onClose: () => void;
  onNavigate?: (direction: 1 | -1) => void;
  onRefresh?: (material: TemporaryMaterial | null) => void;
};

export function TemporaryPreviewModal({ material, onClose, onNavigate, onRefresh }: Props) {
  const temporaryQuery = useTemporaryMaterials();

  return (
    <MaterialPreviewModal
      material={material}
      materialId={material.id}
      onClose={onClose}
      onNavigate={onNavigate}
      showEditControls={true}
      isTemporary={true}
      onRequestRefresh={async (materialId) => {
        try {
          const result = await temporaryQuery.refetch({ throwOnError: false, cancelRefetch: false });
          const allItems = result.data?.pages.flatMap(page => page.items) ?? [];
          const updatedMaterial = allItems.find((item) => item.id === materialId) ?? null;
          onRefresh?.(updatedMaterial);
        } catch (error) {
          console.error('一時素材の再取得に失敗しました:', error);
          const allItems = temporaryQuery.data?.pages.flatMap(page => page.items) ?? [];
          const fallbackMaterial = allItems.find((item) => item.id === materialId) ?? null;
          onRefresh?.(fallbackMaterial);
        }
      }}
    />
  );
}
